import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-about-page',
    templateUrl: './about-page.component.html',
    imports: [RouterLink]
})
export class AboutPageComponent {
}